import { HistoriaDeUsuario } from "../../historiaUsuario";
import { Base } from "../core/base.model";
import { EtapaProyectoBean } from "../incidencias/etapaproyecto.model";
import { Etapa } from "./etapa/etapa";
import { Proyecto } from "./proyecto";

export class SprintModel extends Base{
    id: number;
    nombre: string;
    fechaInicio: number;  
    fechaFin: number; 
    idFase: string; 
    idIteracion:number;
    estatus: string;
    idProyecto: string;

    etapa: Etapa;
    proyecto: Proyecto;

    huAsignadas: HistoriaDeUsuario[];
}